import MGFellowshipSAPage from "./pages/MGFellowshipSAPage";
import Footer from "./components/common/Footer.standalone";
import "./styles/App.css";
import "./styles/utilities.css";

function App() {
  return (
    <>
      <MGFellowshipSAPage />
      <Footer />
    </>
  );
}

export default App;
